import { getEnv } from 'helpers/common'
import { getFormattedPriceWithRouble, getFullNameFromFio } from 'helpers/string'
import { CourierDeliveryInfo, OrderCargoInfo, OrderItem, OrderItemClient } from 'schema'

import { ATTORNEY_FOR_RECEIVE_CARGO, ATTORNEY_FOR_SHIPMENT_CARGO } from '../constants'
import { ORDER_PAYMENT_STATUS, ORDER_STATUS, TOrderClient, TOrderPoint } from '../types'
import { formatCargoVolume, formatCargoVolumeCentimeter3ToMeter3, formatCargoWeightGramToKilogram } from './formatCargo'

export const getPrice = (price: string): string => getFormattedPriceWithRouble(price, true)

export const formattedOrderStatus = (status: any) =>
  // @ts-ignore
  ORDER_STATUS[status]

export const formattedOrderPaymentStatus = (status: any) =>
  // @ts-ignore
  ORDER_PAYMENT_STATUS[status]

export const getFormattedOrderPointName = (orderPoint: TOrderPoint) => {
  if (orderPoint.isCourier) {
    return orderPoint?.addressDetail?.address
  }

  return orderPoint?.terminal?.name
}

export const getFormattedOrderPartnerName = (orderClient: TOrderClient) => {
  if (orderClient.type === OrderItemClient.type.LEGAL) {
    return orderClient?.company?.name
  }

  return getFullNameFromFio({
    lastname: orderClient?.contact?.lastname,
    firstname: orderClient?.contact?.firstname,
    secondname: orderClient?.contact?.secondname
  })
}

export const showPaymentStatus = (paymentStatus: string | undefined) => {
  if (paymentStatus !== ORDER_PAYMENT_STATUS.no) {
    return paymentStatus
  }

  return ''
}

export const formattedOrderStatusStyle = (status: string | undefined, s: any, isMobile?: boolean) => {
  if (status === ORDER_STATUS[OrderItem.Status.CANCEL]) {
    return s.status__cancel
  }
  if (status === ORDER_STATUS[OrderItem.Status.TRANSIT] && isMobile) {
    return s.status__transit
  }

  return ''
}

export const formattedPaymentStatus = (paymentStatus: string | undefined, s: any) => {
  if (paymentStatus === ORDER_PAYMENT_STATUS.part) {
    return s.paymentStatus__warning
  }

  return s.paymentStatus__success
}

export const formattedTotalCargoParamsByType = (
  cargoType?: OrderCargoInfo.type,
  totalWeight?: string,
  totalVolume?: string
) => {
  const totalWeightNatural = Number(totalWeight) ? totalWeight : undefined
  const totalVolumeNatural = Number(totalVolume) ? totalVolume : undefined
  const DASH = '–'
  const MDASH = '—'
  let weight
  let volume

  if (cargoType === OrderCargoInfo.type.TOTAL) {
    weight = formatCargoWeightGramToKilogram(totalWeightNatural, DASH)
    volume = formatCargoVolume(totalVolumeNatural, DASH)
  }

  if (cargoType === OrderCargoInfo.type.SEPARATE) {
    weight = formatCargoWeightGramToKilogram(totalWeightNatural, DASH)
    volume = formatCargoVolumeCentimeter3ToMeter3(totalVolumeNatural, DASH)
  }

  return (weight && Number(totalWeight)) || (volume && Number(totalVolume)) ? `${weight} / ${volume}` : MDASH
}

export const formattedTotalCargoParams = (totalWeight?: string, totalVolume?: string) => {
  const totalWeightNatural = Number(totalWeight) ? totalWeight : undefined
  const totalVolumeNatural = Number(totalVolume) ? totalVolume : undefined
  const DASH = '–'
  const MDASH = '—'
  const weight = formatCargoWeightGramToKilogram(totalWeightNatural, DASH)
  const volume = formatCargoVolume(totalVolumeNatural, DASH)

  return (weight && Number(totalWeight)) || (volume && Number(totalVolume)) ? `${weight} / ${volume}` : MDASH
}

export const formattedSerialId = (serialId: number | undefined) => {
  if (serialId) {
    return `№ ${serialId}`
  }

  return '—'
}

export const formattedDepartureTime = (departureTime: string | undefined) => {
  if (departureTime) {
    return departureTime
  }

  return '—'
}

export const formattedBarcode = (barcode: string | undefined) => {
  if (barcode) {
    return barcode
  }

  return '—'
}

export const deliveryDocsUrl = (pointType: CourierDeliveryInfo.pointType) =>
  pointType === CourierDeliveryInfo.pointType.DEPARTURE ? ATTORNEY_FOR_SHIPMENT_CARGO : ATTORNEY_FOR_RECEIVE_CARGO

export const deliveryRulesUrl = (pointType: CourierDeliveryInfo.pointType) => {
  const rulesUrl = pointType === CourierDeliveryInfo.pointType.DEPARTURE ? 'departureRules' : 'receivingRules'

  return `${getEnv('VITE_REACT_APP_LANDING_URL')}/help/${rulesUrl}`
}

export const formattedCoordinates = (coords: number[], comma?: boolean) => {
  if (coords) {
    return `${coords[0].toFixed(7)}°${comma ? ',' : ''} ${coords[1].toFixed(7)}°`
  }

  return ''
}

export const getCustomerDescription = (
  customerTypeValue: OrderItemClient.type | undefined,
  pointType: CourierDeliveryInfo.pointType
) => {
  if (customerTypeValue === OrderItemClient.type.LEGAL) {
    return 'Я как представитель заказчика'
  }
  if (pointType === CourierDeliveryInfo.pointType.DEPARTURE) {
    return 'Я отправитель'
  }

  return 'Я получатель'
}
